export default "__VITE_ASSET__420tqk2y__"